<template>
  <div>
    <AppHeader />
    <v-container fluid>
      <v-btn color="primary" @click="openDialog" dark>Agregar Procesión</v-btn>

      <!-- Tabla para mostrar las procesiones -->
      <v-data-table :headers="headers" :items="procesiones" sort-by="ID_Procesion" class="elevation-1 mt-4"
        :search="search" :custom-filter="customFilter">
        <template v-slot:top>
          <v-overlay :value="loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-overlay>
          <v-snackbar v-model="NotiExito" :timeout="3000" color="success" top right>
            {{ notiMessage }}
            <template v-slot:action="{ attrs }">
              <v-btn text v-bind="attrs" @click="NotiExito = false">
                Cerrar
              </v-btn>
            </template>
          </v-snackbar>
          <v-snackbar v-model="notiError" :timeout="5000" color="error" top right>
            {{ errorMessage }}
            <template v-slot:action="{ attrs }">
              <v-btn text v-bind="attrs" @click="notiError = false">
                Cerrar
              </v-btn>
            </template>
          </v-snackbar>
          <v-container>
            <v-row justify="end">
              <v-col cols="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template #item.edit="{ item }">
          <div class="d-flex justify-center align-center">
            <v-icon color="info" small class="mr-2" @click="editProcesion(item)">mdi-pencil</v-icon>
          </div>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template #item.actions="{ item }">
          <div class="d-flex justify-center align-center">
            <v-btn small v-if="item.Estado === 'ACTIVA'" color="error" @click="deleteProcesion(item.ID_Procesion)">
              <v-icon left>mdi-arrow-down-box</v-icon>
              Inactivar
            </v-btn>
            <v-btn small color="success" v-if="item.Estado === 'INACTIVA'" class="mr-2"
              @click="ActivateProcesion(item.ID_Procesion)">
              <v-icon left>mdi-arrow-up-box</v-icon>
              Activar
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <!-- Dialog para crear/editar procesiones -->
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ isEditing ? "Editar Procesión" : "Agregar Procesión" }}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-text-field v-model="form.Fecha" label="Fecha de Procesión" type="date" required />
              <v-text-field v-model="form.Ubicacion" label="Ubicación" required />
              <v-text-field v-model="form.Brazos" label="Número de Brazos" type="number" required />
              <v-textarea v-model="form.Descripcion" label="Descripción" required />
              <v-text-field v-model="form.Costo_Inscripcion" label="Costo de Inscripción" type="number" required />
              <v-text-field v-model="form.Costo_Aspirante" label="Costo de Aspirante" type="number" required />
              <v-text-field v-model="form.Costo_honors" label="Costo Honor salida" type="number" />
              <v-text-field v-model="form.Costo_honore" label="Costo Honor entrada" type="number" />
              <v-text-field v-model="form.Mesas" label="Número de mesas" type="number" disabled />
              <v-text-field v-model="form.Recibos_x_mesa" label="Recibos por mesa" type="number" required />
              <!-- <v-text-field v-model="form.Hermandad" label="Hermandad" required />
              <v-select v-model="form.Estado" :items="estados" label="Estado" required /> -->
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="saveBtn">Guardar</v-btn>
            <v-btn color="red darken-1" text @click="closeDialog">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog de sesión expirada -->
      <v-dialog v-model="showSessionExpiredDialog" max-width="400">
        <v-card>
          <v-card-title>¡Sesión expirada!</v-card-title>
          <v-card-text>Tu sesión ha expirado. Por favor, inicia sesión nuevamente.</v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="redirectToLogin">Iniciar sesión</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import AppHeader from "@/components/HeaderC.vue";
import axios from "axios";

export default {
  name: "CrudProcesiones",
  components: {
    AppHeader,
  },
  data() {
    return {
      procesiones: [],
      headers: [],
      search: "",
      NotiExito: false,
      notiError: false,
      errorMessage: "",
      notiMessage: "",
      dialog: false,
      loading: false,
      isEditing: false,
      showSessionExpiredDialog: false,
      form: {
        ID_Procesion: null,
        Fecha: "",
        Ubicacion: "",
        Brazos: 0,
        Descripcion: "",
        Costo_Inscripcion: 0,
        Costo_Aspirante: 0,
        Costo_honors: 0,
        Costo_honore: 0,
        Mesas: 0,
        Recibos_x_mesa: 0
      },
    };
  },
  methods: {
    setHeaders() {

      // Obtén el valor de la cookie
      const hermandadDesc = this.$cookies.get("hermandad") || "Jesús Nazareno de la caída"; // Idioma por defecto: español
      let hermandad;
      if (hermandadDesc === "Jesús Nazareno de la caída") {
        hermandad = "JDC";
      } else if (hermandadDesc === "Virgen de dolores") {
        hermandad = "VDD";
      }

      const headersConfig = {
        JDC: [
          { text: "ID", value: "ID_Procesion" },
          { text: "Fecha de Procesión", value: "Fecha" },
          { text: "Ubicación", value: "Ubicacion" },
          { text: "Número de Brazos", value: "Brazos" },
          { text: "Descripción", value: "Descripcion" },
          { text: "Costo de Inscripción", value: "Costo_Inscripcion" },
          { text: "Costo de Aspirante", value: "Costo_Aspirante" },
          { text: "Costo Honor Mujeres 1", value: "Costo_honors" },
          { text: "Costo Honor Mujeres 2", value: "Costo_honore" },
          { text: "Estado", value: "Estado" },
          { text: "Mesas", value: "Mesas" },
          { text: "Recibos por mesa", value: "Recibos_x_mesa" },
          { text: "Editar", value: "edit", sortable: false },
          { text: "Activar/Inactivar", value: "actions", sortable: false },
        ],
        VDD: [
          { text: "ID", value: "ID_Procesion" },
          { text: "Fecha de Procesión", value: "Fecha" },
          { text: "Ubicación", value: "Ubicacion" },
          { text: "Número de Brazos", value: "Brazos" },
          { text: "Descripción", value: "Descripcion" },
          { text: "Costo de Inscripción", value: "Costo_Inscripcion" },
          { text: "Costo de Aspirante", value: "Costo_Aspirante" },
          { text: "Costo Honor Salida", value: "Costo_honors" },
          { text: "Costo Honor Entrada", value: "Costo_honore" },
          { text: "Estado", value: "Estado" },
          { text: "Mesas", value: "Mesas" },
          { text: "Recibos por mesa", value: "Recibos_x_mesa" },
          { text: "Editar", value: "edit", sortable: false },
          { text: "Activar/Inactivar", value: "actions", sortable: false },
        ]
      };

      // Asignar los headers según el idioma
      this.headers = headersConfig[hermandad] || headersConfig["JDC"];
    },
    normalizeText(text) {
      if (!text) return "";
      return text
        .normalize("NFD") // Descompone caracteres acentuados
        .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
        .toLowerCase(); // Convierte a minúsculas
    },
    customFilter(value, search) {
      if (!value) return false;
      const normalizedValue = this.normalizeText(String(value));
      const normalizedSearch = this.normalizeText(search);
      return normalizedValue.includes(normalizedSearch);
    },
    async fetchProcesiones() {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones?usuarioResponsable=${this.$cookies.get("username")}&incluirDesactivadas=true`;
      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      // this.loading = true; // Activar animación de carga
      // Realizar solicitud GET a la API original con el token en el encabezado
      axios
        .get(apiUrl, config)
        .then((response) => {
          this.procesiones = response.data.records;

          this.loading = false;
        })
        .catch((error) => {
          console.error("Error al obtener las procesiones", error);
          this.loading = false;
        });
    },
    openDialog() {
      this.isEditing = false;
      this.resetForm();
      this.dialog = true;
    },
    editProcesion(procesion) {
      this.isEditing = true;
      this.form = { ...procesion };
      // Convertir la fecha al formato dd-mm-yyyy
      if (this.form.Fecha) {
        const [year, month, day] = this.form.Fecha.split("-");
        this.form.Fecha = `${day}-${month}-${year}`;
      }
      this.dialog = true;
    },
    async saveBtn() {
      if (this.isEditing) {
        this.saveEditProcesion();
      } else {
        this.saveProcesion();
      }
    },
    async saveEditProcesion() {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones/${this.form.ID_Procesion}`;

      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const bodyReq = {
        fecha: this.form.Fecha,
        ubicacion: this.form.Ubicacion,
        brazos: this.form.Brazos,
        descripcion: this.form.Descripcion,
        costoInscripcion: this.form.Costo_Inscripcion,
        costoAspirante: this.form.Costo_Aspirante,
        costoHonors: this.form.Costo_honors ?? 0,
        costoHonore: this.form.Costo_honore ?? 0,
        usuarioResponsable: this.$cookies.get("username"),
        recibosxMesa: this.form.Recibos_x_mesa
      };
      // Realizar solicitud POST a la API original con el token en el encabezado
      axios
        .put(apiUrl, bodyReq, config)
        .then(() => {
          this.fetchProcesiones();
          this.dialog = false;
          this.loading = false;
          this.isEditing = false;
          this.notiMessage = "La procesión ha sido Actualizada correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch(() => {
          this.errorMessage = "Hubo un problema en la Actualización de la procesión ";
          this.notiError = true;
          this.hideNotification();
        });
    },
    async saveProcesion() {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones`;
      //   const apiUrl = `http://localhost:3000/dev/api/procesiones`;
      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const bodyReq = {
        fecha: this.form.Fecha,
        ubicacion: this.form.Ubicacion,
        brazos: this.form.Brazos,
        descripcion: this.form.Descripcion,
        costoInscripcion: this.form.Costo_Inscripcion,
        costoAspirante: this.form.Costo_Aspirante,
        costoHonors: this.form.Costo_honors ?? 0,
        costoHonore: this.form.Costo_honore ?? 0,
        usuarioResponsable: this.$cookies.get("username"),
        recibosxMesa: this.form.Recibos_x_mesa
      };

      // Realizar solicitud POST a la API original con el token en el encabezado
      axios
        .post(apiUrl, bodyReq, config)
        .then(() => {
          this.fetchProcesiones();
          this.dialog = false;
          this.loading = false;
          this.notiMessage = "La procesión ha sido creada correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch(() => {
          this.errorMessage = "Hubo un problema en la creación de la procesión ";
          this.notiError = true;
          this.hideNotification();
        });
    },
    hideNotification() {
      // Logic handled by v-snackbar automatically
    },

    async deleteProcesion(id) {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones/${id}?usuarioResponsable=${this.$cookies.get("username")}`;

      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      // this.loading = true; // Activar animación de carga
      // Realizar solicitud UPDATE a la API original con el token en el encabezado
      axios
        .delete(apiUrl, config)
        .then(() => {
          this.fetchProcesiones();
          this.loading = false;
          this.notiMessage = "La procesión ha sido inactivada correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch((error) => {
          console.error("Error al inactivar la procesión", error);
          this.loading = false;
          this.errorMessage = "Hubo un problema en la inactivación de la procesión ";
          this.notiError = true;
          this.hideNotification();
        });
    },
    async ActivateProcesion(id) {
      this.loading = true;
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones/activate/${id}`;

      const token = this.$cookies.get("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const bodyReq = {
        usuarioResponsable: this.$cookies.get("username"),
      };
      // this.loading = true; // Activar animación de carga
      // Realizar solicitud UPDATE a la API original con el token en el encabezado

      axios
        .put(apiUrl, bodyReq, config)
        .then(() => {
          this.fetchProcesiones();
          this.loading = false;
          this.notiMessage = "La procesión ha sido activada correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch((error) => {
          console.error("Error al Activar la procesión", error);
          this.loading = false;
          this.errorMessage = "Hubo un problema en la activación de la procesión ";
          this.notiError = true;
          this.hideNotification();
        });
    },
    closeDialog() {
      this.dialog = false;
    },
    resetForm() {
      this.form = {
        id: null,
        fechaProcesion: "",
        ubicacion: "",
        numeroBrazos: 0,
        descripcion: "",
        costoInscripcion: 0,
      };
    },
    redirectToLogin() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
      // Redirige al usuario a la página de inicio de sesión
      window.location.href = "/login";
    },
  },
  mounted() {
    this.setHeaders();
    this.fetchProcesiones();
  },
};
</script>
